(function () {
  // Customer switched protection off → do not re-add it for the rest of this visit
  // (#58 decision 8). A SESSION COOKIE, not sessionStorage: sessionStorage is scoped per
  // browsing context, so a decline made in one tab was invisible to a second tab, whose
  // settle path saw default-on and not-declined and re-added the £4.99 the customer had
  // just refused. The line is hidden from the cart's product list, so nothing on screen
  // explained the charge (#61). Every tab of one browser session shares one cookie jar,
  // which is precisely the property sessionStorage lacks. No `expires` and no `Max-Age`
  // on the write, so it dies with the browser session: the decision lasts the VISIT, not
  // forever — the same intent the sessionStorage choice had, now actually delivered.
  // "The visit" is softer than it sounds, and deliberately so: Chrome's "Continue where
  // you left off" and Firefox's "Restore previous session" carry session cookies across a
  // restart, and this now outlives closing every tab, where sessionStorage died with the
  // one that set it. Both errors suppress a charge rather than create one.
  //
  // NOT fixed, and deliberately accepted (#61): a cookie is still per-DEVICE, so a
  // customer who declines on a laptop and reopens the same cart on a phone gets
  // protection back pre-ticked. Carrying the decision across devices means a cart
  // attribute, which would make it last the life of the CART rather than the visit — a
  // change to decision 8 that was weighed and deliberately not taken.
  //
  // This file no longer mirrors cart-free-gift.js's DISMISS_KEY, and that flag is not a
  // parallel to keep in step: it is written twice and READ NOWHERE in the theme, so it is
  // inert. The free gift is never added automatically, so it has no auto-add for a stale
  // flag to mis-gate.
  var DECLINE_KEY = 'lsd_shipping_protection_declined';

  // `path=/` because the drawer is in the DOM on every page, so the flag has to be
  // readable wherever settle() runs — and it is on the DELETE as well as the write,
  // because a delete whose path does not match the write expires a different cookie and
  // leaves the original alive, stranding a customer as declined for the whole visit. No
  // `domain`, so it stays host-only. `SameSite=Lax` is stated rather than left to the
  // browser default, which is not the same in every engine. `Secure` only where the page
  // is already HTTPS: the live storefront always is, and `shopify theme dev` serves plain
  // http on 127.0.0.1. Whether a browser would ACCEPT a Secure cookie on that loopback
  // origin is UNTESTED here (#145) — the conditional is written to be correct without
  // depending on the answer. An earlier version asserted the cookie was silently dropped
  // there and used that to explain a testing surface; README.md records that 127.0.0.1 is
  // not a venue used to test this theme at all — the preview URL is.
  var COOKIE_ATTRS = '; path=/; SameSite=Lax' + (window.location.protocol === 'https:' ? '; Secure' : '');

  // In-memory mirror. Storage THROWS or is silently dropped on iOS Safari with "Block All
  // Cookies", in some in-app webviews, and under privacy extensions — and the catch below
  // swallows it. Without this, a customer on one of those browsers switches protection
  // off, the write silently fails, and the next cart:update re-adds the charge they just
  // declined. The mirror does not survive navigation, but it holds for the page the
  // decision was made on, which is where the re-add would otherwise happen.
  //
  // MOVING TO A COOKIE DOES NOT MAKE THIS REDUNDANT — iOS Safari's "Block All Cookies"
  // is one switch that blocks cookies and Web Storage together, so the environments that
  // swallowed the old write swallow the new one too. It can only force declined TRUE and
  // never false, so every direction it can go stale in biases towards not charging.
  var declinedInMemory = false;

  // Exact name match on purpose: a substring or prefix test would also be satisfied by
  // any other cookie whose name merely contains this one.
  function readCookie(name) {
    var parts = (document.cookie || '').split(';');
    for (var i = 0; i < parts.length; i++) {
      var eq = parts[i].indexOf('=');
      if (eq < 0) continue;
      if (parts[i].slice(0, eq).trim() === name) return parts[i].slice(eq + 1).trim();
    }
    return null;
  }

  function declined() {
    if (declinedInMemory) return true;
    try { return readCookie(DECLINE_KEY) === '1'; } catch (e) { return false; }
  }

  function setDeclined(v) {
    declinedInMemory = !!v;
    try {
      if (v) document.cookie = DECLINE_KEY + '=1' + COOKIE_ATTRS;
      else document.cookie = DECLINE_KEY + '=; Max-Age=0' + COOKIE_ATTRS;
    } catch (e) {}
  }

  // The drawer is in the DOM on every page, so /cart renders TWO of these components —
  // one in the drawer, one in the summary. They are server-rendered from the same cart
  // and therefore always agree, so reading the first is safe. Writes go through section
  // rendering, which re-renders both.
  function root() {
    return document.querySelector('[data-shipping-protection]');
  }

  function attr(el, name) {
    return el ? el.getAttribute(name) : null;
  }

  // /cart/update.js takes { updates: { <variantId>: <absoluteQuantity> } }.
  function setQty(variantId, qty) {
    var u = {};
    u[String(variantId)] = qty;
    return u;
  }

  function qtyInCart(el) {
    var n = parseInt(attr(el, 'data-sp-qty'), 10);
    return isNaN(n) ? 0 : n;
  }

  function otherLines(el) {
    var n = parseInt(attr(el, 'data-sp-other-lines'), 10);
    return isNaN(n) ? 0 : n;
  }

  function getSectionIds() {
    var ids = new Set();
    document.querySelectorAll('[data-section-id]').forEach(function (el) {
      var id = el.dataset.sectionId;
      if (id) ids.add(id);
    });
    return Array.from(ids).join(',');
  }

  // The count the header badge should SHOW: the cart's own count minus protection,
  // which is a charge rather than a basket item and is hidden from the product list.
  //
  // THE FALLBACK, not the primary. countFromSections() below parses the server-rendered
  // `[ref="cartItemCount"]` span out of the section HTML this file already receives, the
  // way cart-free-gift.js has since #60; this recomputation runs only when that span is
  // absent. #62 moved this file onto the parse.
  //
  // WHY THE PARSE IS BETTER: the span has already had cart-display-count.liquid's
  // `product.available` test applied, which JS cannot do — /cart.js line items carry no
  // availability field. snippets/cart-display-count.liquid remains the one definition.
  //
  // NO PRODUCER RECOMPUTES THIS RULE ON ITS PRIMARY PATH, as of #150.
  // snippets/cart-drawer.liquid's `pageshow` handler used to, because it fetched /cart.js
  // with NO `sections` parameter and so had no span to parse. It now asks /?sections=<id> —
  // the GET section rendering the theme already used in sections/ugc-immersive.liquid — and
  // parses the span out of that, in a single request. The displayCount() below and its twin
  // in cart-free-gift.js DO survive as fallbacks and still run, so two copies of the rule
  // remain; they are simply no longer anyone's first source.
  //
  // #73 CLOSED THE AVAILABILITY DIVERGENCE this comment used to describe. The old version
  // matched a hardcoded handle, so it subtracted whenever protection was in the cart —
  // including when the Liquid did NOT, because the Liquid gates on `product.available` and
  // /cart.js line items carry no availability field. Reading the variant id off the
  // rendered component fixes both at once: the id survives a rename, and the component is
  // only in the DOM when the product resolved AND was available, which is exactly when the
  // Liquid subtracts. No component, no attribute, no subtraction — same as the server.
  function displayCount(cart) {
    if (!cart || typeof cart.item_count !== 'number') return null;
    var spVariant = parseInt(attr(root(), 'data-sp-variant'), 10) || 0;
    var n = cart.item_count;
    (cart.items || []).forEach(function (i) {
      if (spVariant && i.variant_id === spVariant) n -= i.quantity || 0;
    });
    return n < 0 ? 0 : n;
  }

  // The count, taken from the SECTION HTML the endpoint just returned. Ported from
  // cart-free-gift.js countFromSections() (#60), which has run on its claim and removal
  // paths since it shipped (committed e852055, 5 Aug 2026); #62 brings this file onto it.
  //
  // WHAT THE PARSE BUYS HERE, precisely: the number is the SERVER's, so it has already
  // had cart-display-count.liquid's `product.available` test applied — which JS cannot do.
  // That is the whole gain. cart-free-gift.js's version of this comment also credits it
  // with being synchronous and needing no extra request; both were true THERE on its CLAIM
  // path, where the alternative was a second /cart.js fetch because /cart/add.js returns no
  // item_count. On that file's five /cart/change.js sites they are as vacuous as they are
  // here — /cart/change.js returns the whole cart, exactly as /cart/update.js does.
  // Here every call site already POSTs to /cart/update.js, which returns the whole cart,
  // so the code being replaced was already synchronous and already made no extra request.
  // Do not carry those two reasons over — here they are vacuous.
  //
  // Key-agnostic ON PURPOSE: it scans every returned section rather than naming one,
  // because getSectionIds() builds the request list from whatever is in the DOM, so the
  // section carrying the span differs between /cart and a page showing only the drawer.
  //
  // Falls back to displayCount(cart) when no section carries the span. That happens when
  // the cart renders its EMPTY branch, where the fallback correctly yields 0; if a section
  // were ever returned without the cart in it; or if DOMParser throws, per the note inside.
  function countFromSections(sections, cart) {
    try {
      for (var key in sections) {
        if (!Object.prototype.hasOwnProperty.call(sections, key)) continue;
        var el = new DOMParser()
          .parseFromString(sections[key], 'text/html')
          .querySelector('[ref="cartItemCount"]');
        if (!el) continue;
        var n = parseInt(String(el.textContent).trim(), 10);
        if (!isNaN(n)) return n < 0 ? 0 : n;
      }
    } catch (e) {}
    // Separate try, deliberately. Folding this into the one above would mean a DOMParser
    // failure skipped the fallback as well, turning a recoverable parse problem into no
    // count at all. And nothing may escape this function: a throw here would abort
    // argument evaluation, so broadcastUpdate would never be called — no cart:update, no
    // section morph, no badge update. Silence beats that.
    try {
      return displayCount(cart);
    } catch (e) {
      return null;
    }
  }

  // Always pass a number. cart-icon.js USED to read
  // `event.detail.data?.itemCount ?? 0`, so dispatching without it silently set the header
  // badge to ZERO on every toggle; as of #150 it ignores a non-numeric itemCount and leaves
  // the badge alone. An omission is still not free — cart-drawer.liquid's analytics listener
  // guards on `typeof newCount !== 'number'` and DROPS the event.
  function broadcastUpdate(sections, source, itemCount) {
    var data = { sections: sections || {}, source: source || 'cart-shipping-protection' };
    if (typeof itemCount === 'number') data.itemCount = itemCount;
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: data } }));
  }

  function track(event, props) {
    try {
      if (window.lsdTrack) window.lsdTrack(event, props || {});
      else if (window.posthog && window.posthog.capture) window.posthog.capture(event, props || {});
    } catch (e) {}
  }

  // One guard for both directions. cart-free-gift.js runs its own debounced reconcile
  // against the same cart and its guards are module-scoped, so neither file can see the
  // other's. This only protects us from ourselves; the cross-file safety comes from the
  // auto-add delay below sitting well clear of that file's 200ms pass.
  var inFlight = false;

  function busy(btn, on) {
    if (!btn) return;
    if (on) btn.setAttribute('aria-busy', 'true');
    else btn.removeAttribute('aria-busy');
  }

  function addProtection(btn, isAuto) {
    var el = btn ? btn.closest('[data-shipping-protection]') : root();
    if (!el || inFlight) return;
    var variantId = attr(el, 'data-sp-variant');
    if (!variantId) return;

    inFlight = true;
    busy(btn, true);
    var startTime = Date.now();

    // SET to exactly 1, never ADD. /cart/add.js INCREMENTS, so any path that reaches it
    // while protection is already in the cart yields quantity 2 — a fast double-click
    // landing after inFlight clears but before the section re-render, or a stale DOM
    // reading 'off' when the cart says otherwise. /cart/update.js sets an absolute
    // quantity keyed by variant, so it is idempotent: no click rate can produce 2.
    // ONE PER CART IS A HARD RULE — the line is hidden from the product list, so a
    // customer charged twice has no quantity control to fix it and no way to see why.
    //
    // Trade-off accepted: update.js takes no line-item properties, so the '_protection'
    // marker is gone. Nothing read it — the theme matches on variant id throughout.
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        updates: setQty(variantId, 1),
        sections: getSectionIds(),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json().then(function (j) { return { json: j, ok: r.ok, status: r.status }; }); })
      .then(function (resp) {
        inFlight = false;
        if (!resp.ok || (resp.json && resp.json.status && resp.json.status >= 400)) {
          track('shipping_protection_add_failed', {
            http_status: resp.status,
            api_status: resp.json && resp.json.status,
            message: resp.json && resp.json.message,
            is_auto: !!isAuto
          });
          busy(btn, false);
          return;
        }
        setDeclined(false);
        track(isAuto ? 'shipping_protection_auto_added' : 'shipping_protection_enabled', {
          duration_ms: Date.now() - startTime
        });
        broadcastUpdate(resp.json.sections, 'cart-shipping-protection-add', countFromSections(resp.json.sections, resp.json));
      })
      .catch(function (err) {
        inFlight = false;
        busy(btn, false);
        track('shipping_protection_add_error', { error_message: err && err.message, is_auto: !!isAuto });
      });
  }

  // autoEvent says WHO removed the line. `false` means the customer switched it off
  // themselves, and that is the only case that sets the decline flag — an automatic
  // removal is housekeeping, and must not silently opt the customer out of an offer they
  // never declined. Anything truthy means WE removed it, and the truthy value IS the
  // tracking event name, so a second automatic path names its own event rather than
  // adding another boolean.
  //
  // It was `isOrphan` until #108, when the quantity clamp in settle() became a second
  // automatic caller that is NOT an orphan removal: passing `true` there would have made
  // the parameter's name false and folded a different failure into the orphan metric.
  //
  // SO NEVER PASS `true`. It is `false` or a string literal, nothing else — track() would
  // send an event literally named `true` and swallow it silently, since it wraps the call
  // in try/catch. #108's own issue text still shows the boolean form as its suggested fix,
  // so anyone copying from there lands exactly on it.
  function removeProtection(btn, key, autoEvent) {
    var el = btn ? btn.closest('[data-shipping-protection]') : root();
    if (!el || inFlight) return;
    var variantId = attr(el, 'data-sp-variant');
    if (!variantId) return;

    inFlight = true;
    busy(btn, true);

    // Keyed by VARIANT rather than line key, matching the add path. A line key can go
    // stale when the cart is mutated in another tab or by the drawer; the variant id
    // cannot. Setting 0 removes the line whatever its current quantity.
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        updates: setQty(variantId, 0),
        sections: getSectionIds(),
        sections_url: window.location.pathname
      })
    })
      // Threaded through as { json, ok, status }, matching addProtection, so the failure
      // exit below can say WHY. The older `r.ok ? r.json() : null` discarded the Response,
      // which is why that exit could only ever have been silent (#112).
      //
      // The inner .catch is load-bearing. r.json() runs on non-ok responses, and a 503 or
      // an edge interstitial carries HTML, which REJECTS — and a rejection lands in the
      // outer .catch, where resp.status is out of scope, losing the status code on exactly
      // the failures this tracking exists to name. Resolving to null instead routes it to
      // the guard below, which tests !resp.json.
      //
      // addProtection has the SAME exposure, not a lesser one: its r.json() is
      // unconditional too, so a non-JSON error body there still loses the status. It is
      // NOT fixed here because its guard has no !resp.json test, so adding this .catch
      // upward without adding that test first would make resp.json.sections throw on a
      // null body. An open hole, deliberately left; recorded on #112.
      .then(function (r) {
        return r.json()
          .catch(function () { return null; })
          .then(function (j) { return { json: j, ok: r.ok, status: r.status }; });
      })
      .then(function (resp) {
        inFlight = false;
        // #112: this exit used to return silently. It is the branch that stops a £4.99 the
        // customer explicitly declined, on a line HIDDEN from the cart's product list — so
        // a customer wrongly charged cannot see why, and nothing recorded that it happened.
        // `autoEvent` is carried because it names WHICH removal failed: a manual decline,
        // an orphan sweep, or decline enforcement.
        if (!resp.ok || !resp.json || (resp.json.status && resp.json.status >= 400) || !resp.json.sections) {
          track('shipping_protection_remove_failed', {
            http_status: resp.status,
            api_status: resp.json && resp.json.status,
            message: resp.json && resp.json.message,
            auto_event: autoEvent || null
          });
          busy(btn, false);
          return;
        }
        if (!autoEvent) {
          setDeclined(true);
          track('shipping_protection_declined', {});
        } else {
          track(autoEvent, {});
        }
        broadcastUpdate(resp.json.sections, 'cart-shipping-protection-remove', countFromSections(resp.json.sections, resp.json));
      })
      .catch(function (err) {
        inFlight = false;
        busy(btn, false);
        track('shipping_protection_remove_error', { error_message: err && err.message, auto_event: autoEvent || null });
      });
  }

  // ── Toggle. The WHOLE component is the hit target, not just the switch. ──
  //
  // Deliberately ONE delegated handler rather than one on the switch and another on
  // the wrapper: a click on the switch bubbles up to the wrapper, so two handlers
  // would fire twice and toggle straight back off again.
  //
  // The info button (the ⓘ, `[data-sp-learn]`) is a real control living inside the hit
  // target, so it has to be excluded or opening the terms would also change the
  // customer's mind for them.
  // The dialog is a SIBLING of the component rather than a child, so clicks inside
  // it never reach here.
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-sp-learn]')) return;
    var el = e.target.closest('[data-shipping-protection]');
    if (!el) return;
    var btn = el.querySelector('[data-sp-toggle]');
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    if (btn.getAttribute('aria-checked') === 'true') removeProtection(btn, null, false);
    else addProtection(btn, false);
  });

  // ── Info dialog, opened by the ⓘ info button (`[data-sp-learn]`) ──
  // Until #204 the opener was a visible "Learn more" text button; the hook is unchanged. The
  // analytics event keeps its old name, shipping_protection_learn_more_opened, so reporting
  // stays continuous: since #204 it fires from the ⓘ button.
  // The component and its dialog render as siblings, so scope the lookup to the shared
  // parent. Falls back to the first dialog in the document, which is safe because every
  // instance renders identical content.
  document.addEventListener('click', function (e) {
    var open = e.target.closest && e.target.closest('[data-sp-learn]');
    if (open) {
      e.preventDefault();
      var comp = open.closest('[data-shipping-protection]');
      var scope = comp && comp.parentElement;
      var dlg = (scope && scope.querySelector('[data-sp-dialog]')) || document.querySelector('[data-sp-dialog]');
      if (dlg && typeof dlg.showModal === 'function') {
        dlg.showModal();
        track('shipping_protection_learn_more_opened', {});
      }
      return;
    }
    var close = e.target.closest && e.target.closest('[data-sp-dialog-close]');
    if (close) {
      e.preventDefault();
      var d = close.closest('[data-sp-dialog]');
      if (d && typeof d.close === 'function') d.close();
    }
  });

  // ── Housekeeping, run after the cart settles ──
  //
  // 1. Protection-only cart. cart-free-gift.js empties a gift-only basket, which can
  //    leave protection as the sole line. The cart is then NOT empty, so the theme
  //    leaves checkout enabled — cart-summary.liquid disables only on
  //    `cart == empty or cs_display_count == 0` (no line number, #49)
  //    and someone could check out having bought nothing but protection.
  // 2. Quantity clamp — or REMOVAL, when the customer has declined (#108). Listed here
  //    because this list reads as complete and omitted the clamp entirely before #108.
  // 3. Auto-add, when the market default is on and the customer has not declined.
  function settle() {
    var el = root();
    if (!el || inFlight) return;

    var isOn = attr(el, 'data-sp-state') === 'on';
    var hasGoods = otherLines(el) > 0;

    if (isOn && !hasGoods) { removeProtection(null, attr(el, 'data-sp-key'), 'shipping_protection_orphan_removed'); return; }

    // Clamp. The set-based add above cannot create a quantity above 1, but a cart cookie
    // predating that fix can already carry one, and the customer has no visible control
    // to correct it. Re-setting to 1 is safe to run on every settle.
    //
    // It sits ABOVE the declined() gate below and returns before ever reaching it, so it
    // has to consult the flag itself (#108). /cart/update.js sets an ABSOLUTE quantity,
    // so it CREATES the line when it is absent — the same property addProtection relies
    // on — which makes this a re-ADD and not merely a clamp. A second tab that rendered
    // while protection was at quantity 2 would otherwise put the £4.99 back on a cart the
    // customer had just switched it off in, with the line hidden from the product list so
    // nothing on screen explained the charge.
    //
    // REMOVE rather than `return`, and do not "simplify" it back into one. Removing is
    // the only direction that cannot charge, and it also RE-SYNCS this tab: the response
    // carries `sections`, which broadcastUpdate morphs into the DOM, so one write brings
    // a stale tab back in step with the real cart. A bare `return` leaves it stale and
    // re-evaluates this same branch on every later cart:update, indefinitely.
    //
    // An earlier version of this comment justified it by "a removal that genuinely
    // failed, leaving the customer at £9.98". THAT STATE IS UNREACHABLE and the argument
    // was wrong: setDeclined(true) fires only on the success path of removeProtection,
    // past the `!data` guard and outside the .catch, so a failed removal leaves
    // declined() FALSE and this branch clamps rather than removes. The state that IS
    // reachable: nothing in this file can produce quantity 2 — every write here is an
    // absolute set — but the product's own page is publicly reachable and /cart/add.js
    // INCREMENTS, so a customer can decline and then add protection twice from there.
    //
    // Deliberately INSIDE the clamp branch rather than hoisted to an `isOn && declined()`
    // gate: hoisting would fire a redundant write and a spurious event on every settle in
    // a stale tab, and would also delete the deliberate two-from-the-PDP purchase above.
    //
    // The residual it leaves is ACCEPTED, NOT ABSENT. `declined()` true with the cart
    // holding quantity 1 is a real £4.99 on a declined cart and nothing here removes it —
    // reachable when a decline in one tab races this clamp in another and the clamp's
    // write lands second. Narrow (two tabs, a legacy quantity-2 cart, a sub-second
    // overlap) and pre-existing, but it is a residual rather than a no-op.
    if (isOn && qtyInCart(el) > 1) {
      if (declined()) {
        removeProtection(null, attr(el, 'data-sp-key'), 'shipping_protection_decline_enforced');
        return;
      }
      inFlight = true;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          updates: setQty(attr(el, 'data-sp-variant'), 1),
          sections: getSectionIds(),
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          inFlight = false;
          if (!data || !data.sections) return;
          track('shipping_protection_qty_clamped', {});
          broadcastUpdate(data.sections, 'cart-shipping-protection-add', countFromSections(data.sections, data));
        })
        .catch(function () { inFlight = false; });
      return;
    }

    if (isOn || !hasGoods) return;
    if (attr(el, 'data-sp-default-on') !== 'true') return;
    if (declined()) return;

    addProtection(null, true);
  }

  // Debounced, so we never fire a cart write while the theme is mid-mutation — the race
  // that could remove the wrong line. 400ms deliberately trails cart-free-gift.js's own
  // 200ms pass rather than colliding with it.
  var timer = null;
  function scheduleSettle(delay) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () { timer = null; settle(); }, delay);
  }

  document.addEventListener('cart:update', function (e) {
    var source = e.detail && e.detail.data && e.detail.data.source;
    if (source === 'cart-shipping-protection-add') return;
    if (source === 'cart-shipping-protection-remove') return;
    scheduleSettle(400);
  });

  document.addEventListener('DOMContentLoaded', function () { scheduleSettle(400); });
})();
